<template>
  <div id="app">
    <div class="content" v-if="reservationKey">
      <Reservation :reservationKey="reservationKey"></Reservation>
    </div>
    <div v-else class="content">
      <ProviderFirstReservationBuilder
        v-if="useProviderFirst"
        :system="system"
        :reference="reference"
        @reservationConfirmed="reservationConfirmed"
      ></ProviderFirstReservationBuilder>
      <ReservationBuilder
        v-else
        @reservationConfirmed="reservationConfirmed"
      ></ReservationBuilder>
    </div>
  </div>
</template>

<script>
import ReservationBuilder from "./components/ReservationBuilder.vue";
import ProviderFirstReservationBuilder from "./components/ProviderFirstReservationBuilder.vue";
import Reservation from "./components/Reservation.vue";

export default {
  name: "App",
  data() {
    return {
      useProviderFirst: false,
      system: undefined,
      reference: undefined,
      reservationKey: undefined,
    };
  },
  components: {
    ReservationBuilder,
    ProviderFirstReservationBuilder,
    Reservation,
  },
  methods: {
    reservationConfirmed(reservationKey, reservation) {
      this.reservationKey = reservationKey;
      console.log(reservation);
      history.pushState({}, "", "/Reservation/" + reservationKey + "/confirmed/" + reservation.services.map(f => f.uniqueKey).join(","));
    },
  },
  created() {
    const queryParams = new URLSearchParams(window.location.search);
    const system = queryParams.get("system");
    const reference = queryParams.get("reference");
    if (system && reference && system.length && reference.length) {
      this.useProviderFirst = true;
      this.system = system;
      this.reference = reference;
    } else if (window.location.pathname.startsWith("/Reservation/")) {
      var paths = window.location.pathname.split("/");
      if (paths.length > 2) {
        this.reservationKey = paths[2];
      }
    }
  },
};
</script>

<style>
*,
::before,
::after {
  box-sizing: border-box;
} /* Switch to border-box for box-sizing. */

body {
  margin: 0; /* Remove the tiny space around the edge of the page */
}

/* Switch to using rem units for typography. Fix line-height on headlines. */
h1 {
  font-size: 2rem; /* Make all H1 large, remove nested-shrinking sizes. */
  margin: 0.67em 0;
}
h2 {
  font-size: 1.5rem;
}
h3 {
  font-size: 1.17rem;
}
h4 {
  font-size: 1rem;
}
h5 {
  font-size: 0.83rem;
}
h6 {
  font-size: 0.67rem;
}

h2,
h3,
h4,
h5,
h6 {
  line-height: 1;
  margin: 0.7rem 0;
}

/* Improve readability */
p,
ul,
ol,
dl,
address {
  line-height: 1.5;
}

pre {
  white-space: pre-wrap; /* Overflow by default is bad. */
}

hr {
  border: 0.5px solid;
}

/* Are browsers now consistent with margin & padding on lists?
  See: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Lists_and_Counters/Consistent_list_indentation  */
nav ul {
  list-style: none;
}

img,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* Switch display mode to block, since that's what we usually want for images. */
  vertical-align: middle; /* If you override, and make an image inline, it's likely you'll want middle vertical alignment. */
}
img,
video {
  max-width: 100%; /* Make images and video flexible by default. */
  height: auto; /* Ensure images and video maintain their aspect ratio when max-width comes into play. */
}
img {
  border-style: none; /* Remove the border on images inside links in IE 10 and earlier. */
}

/* In English, when styling the <q> element, use curly quotes instead of straight quotes. */

/* Code for this is now in the quotes.css file */

/* Support upcoming properties that haven't been broadly implemented yet,
   but for which the initial value and legacy behavior is not be the best behavior.
*/

/* Consistent line spacing, which does not unnecessarily grow to accommodate things that would fit anyway */
/* From CSS Inline Layout Module Level 3: https://drafts.csswg.org/css-inline-3/#line-sizing-property */
:root {
  line-sizing: normal;
}

/* Improve spacing of punctuation marks and at script changes in CJK languages */
/* From CSS Text Module Level 4: https://drafts.csswg.org/css-text-4/#text-spacing-property */
:root {
  text-spacing: trim-start allow-end trim-adjacent ideograph-alpha
    ideograph-numeric;
}
body,
textarea,
button,
input {
  font-family: EuclidTriangle, Arial, Serif;
  font-weight: 400;
  font-size: 18px;
  font-size: 1rem;
  line-height: 1.5;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#app {
  margin-top: 3px;
  min-height: 250vh;
}

input:not([type="checkbox"]):not([type="search"]),
textarea,
select {
  border: 1px solid #c5ced6;
  border-radius: 4px;
  height: 2rem;
  padding: 5px 10px;
  margin-bottom: 15px;
}
input:not([type="checkbox"]):not([type="search"]),
textarea select:focus {
  outline: 0;
  border: 1px solid #c5ced6;
  padding: 5px 10px;
}

@media screen and (min-width: 992px) {
  .content {
    max-width: 90%;
    margin: 0 auto;
  }
}
button,
.button {
  border-radius: 4px;
  padding: 9px 22px;
  border: 0;
  cursor: pointer;
}
button.primary,
.button.primary {
  background-color: #0047bb;
  color: #fff;
}
button.error {
  background-color: #dc3545;
  color: #fff;
}

button[disabled] {
  background-color: lightgray;
  cursor: not-allowed;
}
button.button-xs {
  font-size: 10px;
  padding: 4px 12px;
}
.input-top-label {
  margin-bottom: 5px;
  display: block;
}

/* Colors */

.primary {
  color: #0047bb;
}
.success {
  color: #28a745;
}
.warning {
  color: #ff8241;
}
.error {
  /* color: #dc3545; */
}
div.error,
input.error,
select.error {
  border: 2px solid #dc3545 !important;
}

.font-light {
  font-weight: 300;
}

.font-bold {
  font-weight: 500;
}

.switch {
  position: relative;
  display: inline-block;
  height: 1.3rem;
  max-width: 2.2rem;
  min-width: 2.2rem;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input[disabled],
select[disabled] {
  cursor: not-allowed;
}
.disabled input:checked + .slider {
  background-color: lightgrey;
  cursor: not-allowed;
}
input:checked + .slider {
  background-color: #0047bb;
}

input:focus + .slider {
  box-shadow: 0 0 1px #0047bb;
}

input:checked + .slider:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 30px;
}

.slider.round:before {
  border-radius: 50%;
}
svg[data-prefix="fas"] {
  color: #0047bb;
}
@font-face {
  font-display: swap;
  font-family: "EuclidTriangle";
  font-display: auto;
  font-fallback: Arial, Serif;
  font-weight: 400;
  src: url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Regular.woff2)
      format("woff2"),
    url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Regular.woff)
      format("woff"),
    url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Regular.ttf)
      format("TrueType"),
    url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Regular.eot)
      format("eot");
}

@font-face {
  font-display: swap;
  font-family: "EuclidTriangle";
  font-display: auto;
  font-fallback: Arial, Serif;
  font-weight: 700;
  src: url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Bold.woff2)
      format("woff2"),
    url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Bold.woff)
      format("woff"),
    url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Bold.ttf)
      format("TrueType"),
    url(/custom_clients/incar/client/dist/fonts/EuclidTriangle-Bold.eot)
      format("eot");
}
</style>
